module.exports = __webpack_public_path__ + "assets/4d5b0f7fcb7dfd7e2af7f63714e54a6f.mp3";